import { render, staticRenderFns } from "./PendingTransactionDetails.vue?vue&type=template&id=757254f6&"
import script from "./PendingTransactionDetails.vue?vue&type=script&lang=js&"
export * from "./PendingTransactionDetails.vue?vue&type=script&lang=js&"
import style0 from "./PendingTransactionDetails.vue?vue&type=style&index=0&id=757254f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports